import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, ShieldCheck, Smartphone } from 'lucide-react';

const Footer = () => {
  const links = [
    { label: 'Features', href: '/#features' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Changelog', href: '/changelog' },
    { label: 'Developers', href: '/developers' },
    { label: 'About', href: '/about' },
    { label: 'Privacy', href: '/legal' },
    { label: 'Terms', href: '/legal' },
    { label: 'Help', href: '/about' },
    { label: 'Mobile App (Coming Soon)', href: '/mobile' },
  ];

  return (
    <footer className="border-t border-[var(--isp-divider)]" style={{ backgroundColor: 'var(--isp-glass-inner)' }} data-testid="landing-footer">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        {/* Top row */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-2">
              <img src="/logo-main.png" alt="iStudyPro" className="w-8 h-8 object-contain" />
              <span className="text-lg font-bold">
                <span className="text-[var(--isp-heading)]">iStudy</span>
                <span className="text-[#002FA7]">Pro</span>
              </span>
            </div>
            <p className="text-sm text-[var(--isp-muted)] max-w-xs">
              The social platform for easy learning. Record, study, and grow together.
            </p>
          </div>

          {/* Contact */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-sm text-[var(--isp-muted)]">
            <a href="mailto:info@istudypro.net" className="flex items-center gap-2 hover:text-[#002FA7] transition-colors">
              <Mail className="w-4 h-4" /> info@istudypro.net
            </a>
            <a href="tel:+233246257382" className="flex items-center gap-2 hover:text-[#002FA7] transition-colors">
              <Phone className="w-4 h-4" /> +233 (024) 625-7382
            </a>
          </div>
        </div>

        {/* Links row */}
        <div className="flex flex-wrap gap-x-6 gap-y-2 mb-8">
          {links.map((link) => {
            const isAnchor = link.href.includes('#');
            const handleAnchorClick = (e) => {
              const targetId = link.href.split('#')[1];
              if (window.location.pathname === '/' && targetId) {
                e.preventDefault();
                document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
              }
            };
            return (
              <Link
                key={link.label}
                to={link.href}
                onClick={isAnchor ? handleAnchorClick : undefined}
                className="text-sm text-[var(--isp-body)] hover:text-[#002FA7] transition-colors"
                style={{ fontFamily: 'var(--sf-text)' }}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        {/* Privacy badge */}
        <div className="flex items-start gap-3 p-4 bg-[#002FA7]/5 border border-[#002FA7]/10 mb-8" data-testid="privacy-compliance-badge">
          <ShieldCheck className="w-5 h-5 text-[#002FA7] mt-0.5 shrink-0" />
          <p className="text-xs text-[var(--isp-body)] leading-relaxed">
            <span className="font-semibold text-[var(--isp-heading)]">Privacy Compliant</span> — Built to GDPR, FERPA, and SOC 2 standards. Your audio is processed securely and never used to train AI models.
          </p>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-6 border-t border-[var(--isp-divider)]">
          <p className="text-xs text-[var(--isp-muted)]">
            &copy; 2026 iStudyPRO. A subsidiary of I-Assist Pro Limited.
          </p>
          <div className="flex items-center gap-2 text-xs text-[var(--isp-muted)]">
            <div className="w-2 h-2 rounded-full bg-[#22C55E]" />
            All systems operational
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
